import { render, staticRenderFns } from "./Taobao.vue?vue&type=template&id=295337ea&scoped=true&"
import script from "./Taobao.vue?vue&type=script&lang=js&"
export * from "./Taobao.vue?vue&type=script&lang=js&"
import style0 from "./Taobao.vue?vue&type=style&index=0&id=295337ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295337ea",
  null
  
)

export default component.exports